import { render, staticRenderFns } from "./Tab-VII.vue?vue&type=template&id=3a3a65d0"
import script from "./Tab-VII.vue?vue&type=script&lang=js"
export * from "./Tab-VII.vue?vue&type=script&lang=js"
import style0 from "./Tab-VII.vue?vue&type=style&index=0&id=3a3a65d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports